import React, {PureComponent} from 'react'
import injectSheet from 'react-jss'
import { UnstyledLink } from './Link'
import Section from '../Widgets/Section'
import RichTextContainer from '../Widgets/RichTextContainer'

const Container = ({className, link, children}) => {
  return link ?
    <UnstyledLink className={className} link={link}>{children}</UnstyledLink> :
    <div className={className}>{children}</div>
}

class SectionTitle extends PureComponent {
  render() {
    const {classes, text, summary, link, dataCy} = this.props;
    return (
      <Section className={classes.container} data={dataCy}>
        <Container link={link} className={classes.link}>
          <span className={classes.text}>{text}</span>
        </Container>
        {summary && <RichTextContainer className={classes.summary} content={summary} />}
      </Section>
    )
  }
}

export default injectSheet((theme) => ({
  container: {
    textAlign: 'center',
    marginBottom: 24
  },
  link: {
    display: 'inline-block',
    color: theme.colors.black
  },
  text: {
    textAlign: 'center',
    fontFamily: theme.font.titleFontFamily,
    fontWeight: 'normal',
    position: 'relative',
    paddingLeft: theme.spacing.tiny,
    textTransform: 'uppercase',
    fontSize: theme.getRemValue(26),
    lineHeight: 2,
    display: 'inline-block',
    [theme.breakpoint('tablet')]: {
      fontSize: theme.getRemValue(26),
    }
  },
  summary: {
    ...theme.font.subtitle,
    textAlign: 'center',
    maxWidth: 650,
    margin: [4, 'auto'],
    '& p': {
      fontSize: theme.getRemValue(20),
      lineHeight: 1.5,
    },
    '& p:last-child': {
      margin: 0,
    },
  }
}))(SectionTitle)





// WEBPACK FOOTER //
// ./src/components/Widgets/SectionTitle.js